
import { useState, useCallback } from 'react';

/**
 * Hook for managing basic admin interface state
 * Handles search query and tab selection with enhanced mobile support
 */
export const useAdminInterface = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('attendees');
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [lastSearch, setLastSearch] = useState<string[]>([]);

  // Clear search and optionally hide search interface
  const clearSearch = useCallback(() => {
    setSearchQuery('');
    // Add most recent non-empty search to history if available
    if (searchQuery.trim() && !lastSearch.includes(searchQuery.trim())) {
      setLastSearch(prev => {
        const updated = [searchQuery.trim(), ...prev.slice(0, 4)];
        return [...new Set(updated)]; // Remove duplicates
      });
    }
  }, [searchQuery, lastSearch]);

  // Toggle search visibility for mobile
  const toggleSearchVisibility = useCallback(() => {
    setIsSearchVisible(prev => !prev);
    if (isSearchVisible) {
      setSearchQuery(''); // Clear search when hiding
    }
  }, [isSearchVisible]);
  
  return {
    searchQuery,
    setSearchQuery,
    activeTab,
    setActiveTab,
    isSearchVisible,
    setIsSearchVisible,
    toggleSearchVisibility,
    clearSearch,
    lastSearch
  };
};
